"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateQualityScore = calculateQualityScore;

// Calculate the quality score of the evaluation items
function calculateQualityScore(stateEvaluationItems, propEvaluationItems) {
  let qualityScore = 0; // Go through all the evaluation items for the experiment

  for (let item of propEvaluationItems) {
    const {
      id,
      score,
      evaluationItem: {
        id: evalItemId
      }
    } = item;
    let scoreOfItem; // Verify if item is in state update

    if (Object.keys(stateEvaluationItems).length && stateEvaluationItems[id]) {
      scoreOfItem = stateEvaluationItems[id].score;
    } else {
      scoreOfItem = score ? 5 : 0;
    }

    qualityScore += scoreOfItem; // Verify that the experiment did not have invalid results or automatic 0

    if (evalItemId === 20 && scoreOfItem === 0) {
      qualityScore = 0;
      break;
    }
  }

  return qualityScore;
}